const colorDictionary = [
    {key: 'A', name: 'dark_blue', code: '#167288'},
    {key: 'B', name: 'light_blue', code: '#8cdaec'},
    {key: 'C', name: 'brick_red', code: '#b45248'},
    {key: 'D', name: 'salmon_pink', code: '#d48c84'},
    {key: 'E', name: 'dijon_yellow', code: '#a89a49'},
    {key: 'F', name: 'beige', code: '#d6cfa2'},
    {key: 'G', name: 'green', code: '#3cb464'},
    {key: 'H', name: 'light_green', code: '#9bddb1'},
    {key: 'I', name: 'grape_purple', code: '#643c6a'},
    {key: 'J', name: 'light_purple', code: '#836394'},
    {key: 'K', name: 'lime_green', code: '#66d313'},
    {key: 'L', name: 'yolk_yellow', code: '#fedf17'},
    {key: 'M', name: 'fuscia', code: '#ff0984'},
    {key: 'N', name: 'orange', code: '#f16623'},
    {key: 'O', name: 'dark_green', code: '#415e20'}, 
]

export default colorDictionary